/* ATHLO+ - assets/hub-exit-popup.js
   =================================================================================================
   MOVED OUT OF THE PAGE 2026-08-19. This was a 12.2 KB inline <script> in
   sections/hub-exit-popup.liquid. That section is enabled globally in settings_data.json, so it
   rendered - and re-sent its whole body as uncacheable HTML - on EVERY page view. Measured before
   the move: it was the third-largest inline block on the homepage, behind the vault and an app's.

   The LOGIC IS UNCHANGED, including every part of the 2026-08-03 timing rewrite (the ARM floor,
   the engagement gate, the snooze ladder, the touch/desktop split). Read the comment block at the
   top of the section for why those numbers are what they are - that rationale deliberately stayed
   with the section, next to the schema settings an editor actually turns.

   THE ONLY CODE CHANGE is how the four editor settings arrive. They used to be interpolated by
   Liquid straight into the source:

       var DWELL_MS = {{ section.settings.dwell_seconds | default: 45 }} * 1000;

   which is exactly what forced this to be inline. They now come from `window.HUB_EXITPOP`, a ~90
   byte object the section still emits inline, and each read keeps the SAME default as the Liquid
   filter it replaced, so a missing or partial config behaves identically to an unconfigured
   section. `exitIntent` is compared `!== false` to preserve the original
   `{% if ... == false %}false{% else %}true{% endif %}` - anything other than an explicit false
   means on.
   ================================================================================================= */
(function () {
  'use strict';
  var el = document.getElementById('hub-exit-popup');
  if (!el) return;

  // ---- Tunables (Customizer → Join popup) ---------------------------------
  var CFG         = window.HUB_EXITPOP || {};
  // Defaults softened 2026-09-07 (gentler popup): ~90% of views were dismissed, so the low-intent
  // arrival triggers were demoted — later dwell, deeper scroll, exit-intent off by default, longer
  // snooze. These fallbacks mirror the schema defaults in sections/hub-exit-popup.liquid so the two
  // can't drift (see the comment above HUB_EXITPOP there).
  var DWELL_MS    = (CFG.dwell  != null ? CFG.dwell  : 75) * 1000;
  var SCROLL_PCT  = (CFG.scroll != null ? CFG.scroll : 70) / 100;
  var SNOOZE_DAYS = (CFG.snooze != null ? CFG.snooze : 14);
  var EXIT_INTENT = CFG.exitIntent === true;

  var DAY = 864e5;
  var SNOOZE_REPEAT_DAYS = 45;   // a second dismissal is a firmer "no" than the first (was 30)
  var IDLE_MS = 30000;           // stop counting once they stop interacting
  // No cursor means no exit-intent to read, and a full-card interstitial is far more intrusive on
  // a phone — so touch devices get a higher floor and one fewer trigger.
  var TOUCH   = !window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var ARM_MS  = TOUCH ? 25000 : 15000;  // hard floor of ACTIVE time; nothing may fire before it
  var SEARCH_ARM_MS = 60000;            // landing straight off a search result: highest floor

  // ---- Storage ------------------------------------------------------------
  function ls(k)    { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lset(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function ss(k)    { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  // Guests only (Liquid gates rendering). Don't re-ask someone who joined, and treat a dismissal
  // as a snooze that outlives the session. The legacy 'hub:email:captured' key is still honoured
  // so anyone who gave an email under the old popup isn't nagged again.
  function joined()  { return ls('hub:join:done') === '1' || ls('hub:email:captured') === '1'; }
  function snoozed() { var t = parseInt(ls('hub:join:snooze') || '0', 10) || 0; return t > Date.now(); }

  // ---- Session engagement -------------------------------------------------
  // Pageviews and active time are per-SESSION, not per-page: the old 60s timer restarted on every
  // navigation, so someone reading five pages for four minutes never reached any threshold.
  var views = (parseInt(ss('hub:join:views') || '0', 10) || 0) + 1;
  sset('hub:join:views', String(views));
  var activeMs = parseInt(ss('hub:join:active') || '0', 10) || 0;

  var lastInput = Date.now();
  var engaged = views > 1;   // reaching a second page is itself an engagement signal
  var pointerSeen = false;   // has the cursor ever actually been inside the document?
  var maxY = 0;
  var shown = false, lastFocus = null, pending = null, pendingUntil = 0;

  var fromSearch = (function () {
    var host = '';
    try { host = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
    return /(^|\.)(google|bing|duckduckgo|yahoo|ecosia|baidu)\./i.test(host);
  })();
  function armMs() { return (fromSearch && views < 2) ? Math.max(ARM_MS, SEARCH_ARM_MS) : ARM_MS; }

  // Never interrupt a transactional or account surface.
  // '/pages/trivia-games' added 2026-09-07: the quiz page now shows its own inline "Save your card"
  // panel on the result (hub-athlete-card.js buildCaptureUI), so a popup there is a redundant second
  // ask. Suppress it on that page and let the in-context panel do the capturing.
  // '/products/', '/collections/', '/search' added 2026-10-26: those are the pages that produce carts, and on a
  // phone the modal covered the product description before Add to cart was reachable. The join ask still runs
  // on the homepage, articles, club pages and Shoe Lab. ('/collections/' also covers /collections/x/products/y.)
  var QUIET = ['/cart', '/checkout', '/account', '/customer_authentication', '/password', '/policies', '/challenge', '/apps/', '/tools/', '/pages/trivia-games', '/products/', '/collections/', '/search'];
  // The WMM campaign quiz (hub-wmm-quiz) is the same case as trivia-games: its result screen
  // carries its own ATHLO+ join form, so this popup landing on top of it (seen 2026-09-29, over
  // a Berlin result on a phone) is a second ask competing with the first. Keyed on the quiz's
  // own root hook rather than a URL, so it holds on /pages/wmm-quiz, on a ?view=wmm-quiz
  // preview, and on whatever page the owner eventually puts the section.
  function quietPage() {
    if (document.querySelector('[data-wmm-quiz]')) return true;
    var p = (location.pathname || '').toLowerCase();
    for (var i = 0; i < QUIET.length; i++) if (p.indexOf(QUIET[i]) === 0) return true;
    return false;
  }
  // Something else already owns the screen — wait rather than stack a modal on a modal.
  function busy() { return !!document.querySelector('.cart-drawer.is-open, .search-panel.is-open, .hubjoin.is-open, .hub-salepop.is-open'); }

  // Hard blocks can never clear during this pageview; soft blocks (floor, engagement, another
  // panel open) can, which is why a held intent is worth re-checking.
  function hardBlocked() {
    return shown || joined() || snoozed() || ss('hub:email:popup:seen') === '1' || quietPage();
  }
  function canShow() {
    if (hardBlocked()) return false;
    if (activeMs < armMs()) return false;
    if (!engaged) return false;
    if (busy()) return false;
    return true;
  }
  // Triggers raise an INTENT, not the popup. If the floor hasn't been reached or a drawer is open,
  // the intent is held for up to 90s and re-checked each tick — deferred, not lost.
  function request(reason) {
    if (hardBlocked()) return;
    if (canShow()) { show(reason); return; }
    pending = reason;
    pendingUntil = Date.now() + 90000;
  }
  // Focus management: the old markup declared role="dialog" aria-modal="true" but never moved
  // focus in, never trapped Tab and never restored focus on close, so keyboard and screen-reader
  // users were left behind the overlay with no way back.
  function focusables() {
    return [].slice.call(el.querySelectorAll('a[href], button:not([disabled])'))
      .filter(function (n) { return n.offsetParent !== null; });
  }
  function onKeydown(e) {
    if (e.key === 'Escape') { dismiss(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function show(reason) {
    if (!canShow()) return;
    shown = true; pending = null;
    try { sessionStorage.setItem('hub:email:popup:seen', '1'); } catch (e) {}
    lastFocus = document.activeElement;
    el.hidden = false; el.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown);
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      // The Google button is hidden in an app's own browser (hub-inapp.js — Shopify's hosted
      // OAuth cannot finish there), and focus() on a display:none node silently does nothing,
      // which would leave a modal open with focus still behind it. Tested for VISIBILITY rather
      // than for the reason, so any future cause of it being hidden lands on its feet too.
      var g = document.getElementById('hub-popup-google');
      if (g && !g.offsetParent) g = document.getElementById('hub-popup-alt');
      if (g) { try { g.focus(); } catch (e) {} }
    });
    // `origin`, never `source`: GA4 reads an event param named `source` as the session's traffic
    // source, so every popup view was relabelling the visit "popup / social" etc. (2026-10-27).
    try { if (window.HubTrack) window.HubTrack('join_popup_view', { origin: 'popup', trigger: reason || 'unknown', active_seconds: Math.round(activeMs / 1000), pageviews: views }); } catch (e) {}
  }
  function hide() {
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    setTimeout(function () {
      el.hidden = true; el.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }, 400);
  }

  // ---- Attention clock ----------------------------------------------------
  // ACTIVE time only: a background tab and an abandoned laptop both earn nothing, so the dwell
  // trigger measures attention rather than wall-clock.
  function noteInput() { lastInput = Date.now(); }
  ['mousemove', 'keydown', 'touchstart', 'pointerdown', 'wheel'].forEach(function (evt) {
    document.addEventListener(evt, noteInput, { passive: true });
  });
  document.addEventListener('mousemove', function () { pointerSeen = true; }, { passive: true });
  document.addEventListener('click', function () { noteInput(); engaged = true; }, true);
  document.addEventListener('keydown', function () { engaged = true; }, true);

  setInterval(function () {
    if (document.visibilityState === 'hidden') return;
    if (Date.now() - lastInput > IDLE_MS) return;
    activeMs += 1000;
    sset('hub:join:active', String(activeMs));
    if (!shown && !pending && activeMs >= DWELL_MS) request('dwell');
    if (pending) {
      if (Date.now() > pendingUntil || hardBlocked()) pending = null;
      else if (canShow()) { var r = pending; pending = null; show(r); }
    }
  }, 1000);

  // ---- Triggers -----------------------------------------------------------
  // Each of these only raises an intent; request() enforces the floor, the engagement signal, the
  // quiet pages and the once-per-session cap.
  // 1) Athlete-quiz completion no longer triggers this popup (2026-09-07). The quiz result screen
  //    now carries its own in-context "Save your card — join free" panel (hub-athlete-card.js
  //    buildCaptureUI), which is a better, non-stacking capture at the same moment. Firing the modal
  //    1.6s after quiz_complete on top of that inline panel was a redundant double-ask, so it was
  //    removed. (The quiz page is also in QUIET above, belt-and-braces.)
  // 2) Add-to-cart attempt — <form action="…/cart/add"> and AJAX /cart/add.js. The cart drawer
  //    opens on the same action, so this waits for them to be done with the bag (busy() holds it).
  function cartIntent() {
    engaged = true;
    setTimeout(function () { request('cart'); }, 6000);
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && String(f.action).indexOf('/cart/add') > -1) cartIntent();
  }, true);
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/cart/add') > -1) cartIntent();
      } catch (e) {}
      return _fetch.apply(this, arguments);
    };
  }
  // 3) Scroll depth, on any long page. Two conditions, not one: this site's pages grow as sections
  //    and media load, so a raw percentage can be satisfied by a single flick while the layout is
  //    still short. Requiring two viewports of real travel as well makes it mean what it says.
  var ticking = false;
  window.addEventListener('scroll', function () {
    noteInput();
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (y > maxY) maxY = y;
      if (!engaged && maxY > (TOUCH ? window.innerHeight * 1.5 : 400)) engaged = true;
      if (shown || pending) return;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && maxY > window.innerHeight * 2 && maxY / h >= SCROLL_PCT) request('scroll');
    });
  }, { passive: true });
  // 4) Desktop exit-intent. This is the one that used to fire on arrival: it needs the cursor to
  //    have actually been inside the page (a pointer parked over the browser chrome at load can no
  //    longer trip it) and, like everything else, it goes through the arm floor in request().
  if (EXIT_INTENT && !TOUCH) {
    document.addEventListener('mouseleave', function (e) {
      if (!pointerSeen || e.clientY > 0) return;
      request('exit');
    });
  }

  // ---- Close --------------------------------------------------------------
  // Closing is a "not now", so it snoozes across sessions instead of only this one; twice is a
  // "no", and buys a month of quiet.
  function dismiss() {
    hide();
    var n = (parseInt(ls('hub:join:dismissals') || '0', 10) || 0) + 1;
    lset('hub:join:dismissals', String(n));
    lset('hub:join:snooze', String(Date.now() + (n >= 2 ? SNOOZE_REPEAT_DAYS : SNOOZE_DAYS) * DAY));
    try { if (window.HubTrack) window.HubTrack('join_popup_dismiss', { count: n }); } catch (e) {}
  }
  // (Escape is handled inside onKeydown, which is only bound while the dialog is open.)
  /* NO OPTIONAL CHAINING IN STOREFRONT JS (2026-08-29). `?.` is ES2020, and a browser that cannot
     parse it does not skip the line — it throws SyntaxError and abandons the ENTIRE FILE. This file
     is loaded on every page, so two characters here silently disabled the whole join popup for every
     visitor on an older Android Chrome. Real users hit exactly this: HUAWEI P30 Pro (Android 10) and
     Xiaomi MI 8 (Android 8.1) logged "Uncaught SyntaxError: Unexpected token ." against athlo.sg,
     which is a meaningful slice of devices in Singapore. The verbose form costs nothing. */
  var popupClose = document.getElementById('hub-popup-close');
  if (popupClose) popupClose.addEventListener('click', dismiss);
  var popupOverlay = document.getElementById('hub-popup-overlay');
  if (popupOverlay) popupOverlay.addEventListener('click', dismiss);

  // ---- Join → hosted customer accounts (Google / Shop / email) -------------
  // No form to submit: the CTA is a real link, so it still works if JS fails and it supports
  // middle-click / open-in-new-tab. We only mark intent + fire analytics on the way out.
  ['hub-popup-google', 'hub-popup-alt'].forEach(function (id) {
    var a = document.getElementById(id);
    if (!a) return;
    a.addEventListener('click', function () {
      try { localStorage.setItem('hub:join:done', '1'); } catch (e) {}
      try { if (window.HubTrack) window.HubTrack('join_popup_click', { method: id === 'hub-popup-google' ? 'google' : 'other' }); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent('hub:join_intent', { detail: { source: 'popup' } })); } catch (e) {}
    });
  });
})();
